import React from 'react'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import { AccessType, useCompany } from 'zens-store'
import { Button, Text } from 'zens-storybook'
import { usePermissions } from '@dms/hook'

import { InfoBlock, InfoTable } from '..'

const styles = StyleSheet.create({
  container: {},
  info: {
    maxWidth: '100%',
  },
  skeletonRow: {
    height: 32,
  },
  skeletonTitle: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
})

interface Props extends ViewProps {
  companyId: number
}
const CompanyRegularSync = (props: Props) => {
  const { companyId, style, ...otherProps } = props
  const { t } = useTranslation()
  const company = useCompany({ companyId })
  const { hasRegularSync } = company.data || {}
  const { hasPermission } = usePermissions(companyId)

  if (!hasPermission(AccessType.Read, 'settings')) return null

  const config = {
    fields: [{ label: t('Status'), value: hasRegularSync ? t('Active') : t('Inactive') }],
  }

  return (
    <InfoTable
      title={t('Regular sync')}
      companyId={companyId}
      contentContainerStyle={styles.info}
      config={config}
      buttonTitle={t('Edit')}
      buttonHref={hasPermission(AccessType.Update, 'settings') ? `/companies/${companyId}/regular-sync` : undefined}
      style={[styles.container, style]}
      {...otherProps}
    />
  )
}

interface SkeletonProps extends ViewProps {}
const Skeleton = (props: SkeletonProps) => {
  const { t } = useTranslation()
  return (
    <InfoBlock.Skeleton
      title={
        <View style={styles.skeletonTitle}>
          <Text level={4}>{t('Regular sync')}</Text>
          <Button.Skeleton />
        </View>
      }
      {...props}
    >
      <Text.Skeleton style={styles.skeletonRow} />
    </InfoBlock.Skeleton>
  )
}
CompanyRegularSync.Skeleton = Skeleton

export default observer(CompanyRegularSync)
